
export default {
    path: 'file-config',
    name: 'company-file-config',
    meta: {
        title: '项目附件管理'
    },
    component: () => import('@/pages/company/fileConfig/Index'),
    redirect: {
        name : 'company-file-config-land',
    },
    children: [
        {
            path: 'land',
            name: 'company-file-config-land',
            meta: {
                title: '项目附件管理-单位管理'
            },
            component: () => import('@/pages/company/fileConfig/List'),
        },
        {
            path: 'factory',
            name: 'company-file-config-factory',
            meta: {
                title: '项目附件管理-单位管理'
            },
            component: () => import('@/pages/company/fileConfig/List'),
        },
        {
            path: 'officebuilding',
            name: 'company-file-config-officebuilding',
            meta: {
                title: '项目附件管理-单位管理'
            },
            component: () => import('@/pages/company/fileConfig/List'),
        },
        {
            path: 'warehouse',
            name: 'company-file-config-warehouse',
            meta: {
                title: '项目附件管理-单位管理'
            },
            component: () => import('@/pages/company/fileConfig/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/company/fileConfig/index.js